import { isMobile } from "mobile-device-detect";
import { Settings } from "@/constant";

export const getTransformMatrix = (myElement) => {
  const MatrixAPI = window["DomMatrix"] || window.WebKitCSSMatrix;
  const currentMatrix =
    getComputedStyle(myElement).getPropertyValue("transform");
  return new MatrixAPI(currentMatrix);
};

export const tranformOriginOfElement = (element, x, y) =>{
  const vendors = [
    "-webkit-transform",
    "-moz-transform",
    "-ms-transform",
    "-o-transform",
    "transform",
  ];
  for (const vendor of vendors) {
    element.style[vendor] = `scale(${x}, ${y})`;
  }
};

export const fitSVGToModal = (defaultScale: number) => {
  const div = document.getElementById("crop");
  const svg = div?.getElementsByTagName("svg")[0];
  svg?.setAttribute("width", div?.clientWidth + "px");
  svg?.setAttribute("height", div?.clientHeight + "px");
  svg?.setAttribute("style", ``);
  tranformOriginOfElement(svg, defaultScale, defaultScale);
  svg?.setAttribute("preserveaspectratio", "xMidYMid meet");
}

export const getPositiveValue = (val) => {
  const item = val < 0 ? val * -1 : val;
  return item;
};

export const normalZoomIn = (svgZoom, zoomStep) => {
  const zoomParams = {
    isDisabledZoomIn: false,
    isDisabledZoomOut: false,
    svgZoom
  }
  let newSvgZoom = svgZoom + zoomStep;

  const mapMaxValue = isMobile
    ? Settings.MOBILE_MAX_SVG_SCALE
    : Settings.WEB_MAX_SVG_SCALE;
  const mapMinValue = 1;
  if (newSvgZoom >= mapMaxValue) {
    zoomParams.isDisabledZoomIn = true;
    newSvgZoom = mapMaxValue;
  } else {
    zoomParams.isDisabledZoomIn = false;
  }
  if (newSvgZoom <= mapMinValue) {
    zoomParams.isDisabledZoomOut = true;
    newSvgZoom = mapMinValue;
  } else {
    zoomParams.isDisabledZoomOut = false;
  }
  zoomParams.svgZoom = newSvgZoom;

  return zoomParams;
};

export const closeDragElement = () => {
  if (isMobile) {
    document.ontouchend = null;
    document.ontouchmove = null;
  } else {
    document.onmouseup = null;
    document.onmousemove = null;
  }
}